var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.76 13.3401H22.04L26.68 17.4001V13.3401C27.666 13.3401 28.42 12.5861 28.42 11.6001V2.32008C28.42 1.33408 27.666 0.580078 26.68 0.580078H12.76C11.774 0.580078 11.02 1.33408 11.02 2.32008V11.6001C11.02 12.5861 11.774 13.3401 12.76 13.3401Z",
    stroke: "#192643",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.98 14.4996V22.6196C17.98 23.6056 17.226 24.3596 16.24 24.3596H6.96002L2.32002 28.4196V24.3596C1.33402 24.3596 0.580017 23.6056 0.580017 22.6196V13.3396C0.580017 12.3536 1.33402 11.5996 2.32002 11.5996H9.86002",
    stroke: "#192643",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.082 8.46809L18.734 10.2081H17.69L19.14 3.53809H20.358L21.75 10.2081H20.706L20.358 8.46809H19.082ZM20.3 7.65609L20.01 6.14809C19.894 5.74209 19.836 5.10409 19.778 4.64009H19.72C19.662 5.10409 19.546 5.74209 19.488 6.14809L19.198 7.65609H20.3ZM10.846 22.2141C10.324 21.9821 9.62796 21.6341 9.22196 21.4021C9.10596 21.3441 8.98996 21.2861 8.93196 21.2861C7.71396 21.2861 6.95996 20.1261 6.95996 17.8641C6.95996 15.8921 7.71396 14.5001 9.04796 14.5001C10.44 14.5001 10.962 16.0081 10.962 17.8061C10.962 19.5461 10.556 20.5321 9.91796 20.8801V20.9381C10.324 21.1121 10.788 21.2861 11.194 21.4021L10.846 22.2141ZM8.98996 20.3581C9.62796 20.3581 9.85996 19.1981 9.85996 17.8061C9.85996 16.5301 9.62796 15.3701 8.98996 15.3701C8.29396 15.3701 8.06196 16.5881 8.06196 17.8061C8.06196 19.1981 8.29396 20.3581 8.98996 20.3581Z",
    fill: "#192643"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.20b870a72b02be48289d3c0fb6f70ac8.svg";
export { ForwardRef as ReactComponent };